import { render, staticRenderFns } from "./GoClassSteptwo.vue?vue&type=template&id=7baee9fa&scoped=true"
import script from "./GoClassSteptwo.vue?vue&type=script&lang=js"
export * from "./GoClassSteptwo.vue?vue&type=script&lang=js"
import style0 from "./GoClassSteptwo.vue?vue&type=style&index=0&id=7baee9fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baee9fa",
  null
  
)

export default component.exports